import script from "./TaxIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./TaxIndex.vue?vue&type=script&setup=true&lang=js"

import "./TaxIndex.vue?vue&type=style&index=0&id=17920aa2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17920aa2"]])

export default __exports__